import axios from "axios";
import { adnPageSize } from "../components/common/GeneralConfigurations";
import { baseApiUrl, getHttpHeaders, httpRequest } from "./ApiUtils";

const EmployeeRecommendationBenefitsApiUrl = `${baseApiUrl}/api/EmployeeRecommendationBenefits`;

export const getEmployeeRecommendationBenefits = async (
  pageNumber = 1,
  pageSize = adnPageSize,
  orderBy = "",
  employeeName = "",
  referencedByName = "",
  payment = null,
  benefitStatus = null,
  month = null,
  year = null
) => {
  return await httpRequest(
    fetchEmployeeRecommendationBenefits.bind(
      this,
      pageNumber,
      pageSize,
      orderBy,
      employeeName,
      referencedByName,
      payment,
      benefitStatus,
      month,
      year
    )
  );
};

const fetchEmployeeRecommendationBenefits = async (
  pageNumber,
  pageSize,
  orderBy,
  employeeName,
  referencedByName,
  payment,
  benefitStatus,
  month,
  year
) => {
  let config = getHttpHeaders();
  return await axios.get(
    `${EmployeeRecommendationBenefitsApiUrl}?OrderBy=${orderBy}&PageSize=${pageSize}&pageNumber=${pageNumber}&EmployeeName=${employeeName}&ReferencedByName=${referencedByName}&Payment=${payment}&BenefitStatus=${benefitStatus}&Month=${month}&Year=${year}`,
    config
  );
};

export const getEmployeeRecommendationBenefitsByEmployeeId = async (id) => {
  return await httpRequest(
    fetchEmployeeRecommendationBenefitsByEmployeeId.bind(this, id)
  );
};

const fetchEmployeeRecommendationBenefitsByEmployeeId = async (id) => {
  let config = getHttpHeaders();
  return await axios.get(
    `${EmployeeRecommendationBenefitsApiUrl}/${id}`,
    config
  );
};

export const getEmployeeRecommendationBenefitsByReferencedById = async (id) => {
  return await httpRequest(
    fetchEmployeeRecommendationBenefitsByReferencedById.bind(this, id)
  );
};

const fetchEmployeeRecommendationBenefitsByReferencedById = async (id) => {
  let config = getHttpHeaders();
  return await axios.get(
    `${EmployeeRecommendationBenefitsApiUrl}/ReferencedBy/${id}`,
    config
  );
};

export async function addEmployeeRecommendationBenefit(
  newEmployeeRecommendationBenefit
) {
  return await httpRequest(
    postEmployeeRecommendationBenefit.bind(
      this,
      newEmployeeRecommendationBenefit
    )
  );
}

async function postEmployeeRecommendationBenefit(
  newEmployeeRecommendationBenefit
) {
  let config = getHttpHeaders();
  return await axios.post(
    `${EmployeeRecommendationBenefitsApiUrl}`,
    newEmployeeRecommendationBenefit,
    config
  );
}

export async function updateEmployeeRecommendationBenefit(
  employeeRecommendationBenefit
) {
  return await httpRequest(
    putEmployeeRecommendationBenefit.bind(this, employeeRecommendationBenefit)
  );
}

async function putEmployeeRecommendationBenefit(employeeRecommendationBenefit) {
  let config = getHttpHeaders();
  return await axios.put(
    `${EmployeeRecommendationBenefitsApiUrl}`,
    employeeRecommendationBenefit,
    config
  );
}

export async function updateCanceledEmployeeRecommendationBenefits(id) {
  return await httpRequest(
    putCanceledEmployeeRecommendationBenefit.bind(this, id)
  );
}

async function putCanceledEmployeeRecommendationBenefit(id) {
  let config = getHttpHeaders();
  return await axios.put(
    `${EmployeeRecommendationBenefitsApiUrl}/Cancel`,
    id,
    config
  );
}

export async function deleteEmployeeRecommendationBenefit(id) {
  return await httpRequest(
    fetchDeleteEmployeeRecommendationBenefit.bind(this, id)
  );
}

async function fetchDeleteEmployeeRecommendationBenefit(id) {
  let config = getHttpHeaders();
  return await axios.delete(
    `${EmployeeRecommendationBenefitsApiUrl}/${id}`,
    config
  );
}
